/**
 * AI 시나리오 플래닝 — 타이포그래피 토큰 (전역 표준으로의 얇은 별칭)
 *
 * 이 토큰이 원래 AI 화면 전용 스케일이었는데, 전역 폰트 표준의 원형이 되면서
 * **값을 갖지 않고 전역 `FS` 를 가리키기만 한다.** 규칙·역할표는
 * `saas-web/.claude/skills/typography/SKILL.md` 가 정본이다.
 *   → AI 화면의 `FONT.*` 사용처 약 1,022곳을 손대지 않고 Big/Small 토글에 편입시킨다.
 *
 * ⚠️ **값이 이제 `"var(--fs-body)"` 같은 CSS 문자열이라 산술에 못 쓴다.**
 *   `FONT.SUB + 2` 처럼 계산이 필요하거나 canvas 에 넘겨야 하면
 *   `getFontSizePx("sub")`(font-util.js)로 해석된 px 숫자를 받을 것.
 *
 * (주의) 이 토큰은 **텍스트 전용**이다. MUI 아이콘(<XIcon sx={{fontSize:..}}>) 크기에는 쓰지 않는다.
 *   (아이콘은 레이아웃 안정성을 위해 기존 fontSize 를 유지한다.)
 */
import { FS } from "@plannel/utils/font-util";
export const FONT = {
  MICRO:   FS.CAPTION,   // 역할 폐지 → caption 흡수 (10px 미만 금지 규칙의 연장)
  CAPTION: FS.CAPTION,   // 칩·테이블 헤더·보조 라벨
  BODY:    FS.BODY,      // 기본 본문·필드·파라미터
  SUB:     FS.SUB,       // 부제·이슈 설명·카테고리
  TITLE:   FS.TITLE,     // 섹션·시나리오 제목
  H2:      FS.H2,        // 모듈 제목·주요 헤더
  H1:      FS.H1,        // 히어로 타이틀 (DecisionHero 등)
  FORMULA: FS.DISPLAY,   // 안전재고 수식 표시 — 구 이름 별칭
  KPI:     FS.KPI,       // KPI 헤드라인 숫자
};
